import React, { useCallback, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faPlus } from '@fortawesome/pro-solid-svg-icons';
import { useTranslation } from 'react-i18next';

import { useReactBasket } from '@basket/hooks/useReactBasket';

import FlexBox from '@ess/ui/FlexBox';
import Tooltip from '@ess/ui/Tooltip';

import CreateBasketModal from 'apps/basket/src/components/CreateBasketModal';

import { isMobileOnly } from 'react-device-detect';
import Checkbox from '@ess/ui/Form/Checkbox';
import Text from '@ess/ui/Text';
import { useAppConfig } from '@ess/context/AppConfigContext';
import BasketActions from '../BasketActions';

import { Styled } from './Header.styles';

const Header = () => {
  const [isOpenModal, setIsOpenModal] = useState(false);
  const { t } = useTranslation();
  const {
    basket,
    selectAllItems,
    changeBasket,
    createBasket,
    deleteBookmark,
  } = useReactBasket();
  const { maxBasketItems } = useAppConfig();

  return (
    <Styled.Basket__Header
      showHeader={!isMobileOnly && ['right', 'left'].includes(basket.position)}
    >
      {isOpenModal && (
        <CreateBasketModal
          onApply={createBasket}
          onClose={() => {
            setIsOpenModal(false);
          }}
        />
      )}
      <FlexBox ml="auto" alignItems="center">
        {!isMobileOnly && ['right', 'left'].includes(basket.position) && (
          <FlexBox mr="10px" alignItems="center">
            <Text ml="tiny" color="textColor">
              {`${t('lbl_basket_items_count')}: ${basket.count}/${maxBasketItems}`}
            </Text>
          </FlexBox>
        )}
      </FlexBox>
    </Styled.Basket__Header>
  );
};

export default Header;
